module.exports = __webpack_public_path__ + "static/img/3220.15ad2e8a.jpg";